<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<div id="home-p" class="home-p pages-head1 text-center">
  <div class="container">
    <h1 class="wow fadeInUp" data-wow-delay="0.1s">Servicios y soluciones</h1>
    <p>MundoFinanciera</p>
  </div>
</div>

<section id="business-growth-p1" class="business-growth-p1 bg-gray">
  <div class="container">
    <div class="row title-bar">
      <div class="col-md-12">
        <p class="wow fadeInUp" data-wow-delay="0.4s">Te ofrecemos servicios y soluciones de acuerdo a tus necesidades</p>
      </div>
    </div>
    <div class="row wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
      <div class="col-md-4 col-sm-6 justify-content-center service-padding">
          <div class="service-item">
            <a href="https://micrositios.goupagos.com.co/mundo-financiera-sas-mc/login" target="_blank">
              <div class="service-item-icon"> <i class="fa fa-money fa-3x"></i>
              </div>
              <div class="service-item-title">
                  <h3>Pague aquí</h3>
              </div>
              <!--<div class="service-item-desc">
                  <p>Laborum adipisicing do amet commodo occaecat do amet commodo occaecat.</p>
                  <div class="content-title-underline-light"></div>
              </div>-->
            </a>
          </div>
      </div>
      <div class="col-md-4 col-sm-6 justify-content-center service-padding">
          <div class="service-item">
            <a [routerLink]="['../consulta-pago']">
              <div class="service-item-icon"> <i class="fa fa-laptop fa-3x"></i>
              </div>
              <div class="service-item-title">
                  <h3>Consulta de pagos</h3>
              </div>
              <!--<div class="service-item-desc">
                  <p>Laborum adipisicing do amet commodo occaecat do amet commodo occaecat.</p>
                  <div class="content-title-underline-light"></div>
              </div>-->
            </a>
          </div>
      </div>
      <div class="col-md-4 col-sm-6 justify-content-center service-padding">
          <div class="service-item">
            <a [routerLink]="['../firma-electronica']">
              <div class="service-item-icon"> <i class="fa fa-pencil fa-3x"></i>
              </div>
              <div class="service-item-title">
                  <h3>Firma electrónica de su crédito</h3>
              </div>
              <!--<div class="service-item-desc">
                  <p>Laborum adipisicing do amet commodo occaecat do amet commodo occaecat.</p>
                  <div class="content-title-underline-light"></div>
              </div>-->
            </a>
          </div>
      </div>
      <div class="col-md-4 col-sm-6 justify-content-center service-padding">
          <div class="service-item right-bord">
            <a [routerLink]="['../solicitud-credito']">
              <div class="service-item-icon"> <i class="fa fa-file-text-o fa-3x"></i>
              </div>
              <div class="service-item-title">
                  <h3>Solicitudes de Crédito</h3>
              </div>
              <!--<div class="service-item-desc">
                  <p>Laborum adipisicing do amet commodo occaecat do amet commodo occaecat.</p>
                  <div class="content-title-underline-light"></div>
              </div>-->
            </a>
          </div>
      </div>
      <div class="col-md-4 col-sm-6 justify-content-center service-padding">
        <div class="service-item right-bord">
          <a [routerLink]="['../cpunto-pago']">
            <div class="service-item-icon"> <i class="fa fa-search fa-3x"></i>
            </div>
            <div class="service-item-title">
                <h3>Puntos de Pago</h3>
            </div>
            <!--<div class="service-item-desc">
                <p>Laborum adipisicing do amet commodo occaecat do amet commodo occaecat.</p>
                <div class="content-title-underline-light"></div>
            </div>-->
          </a>
        </div>
    </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
